import KeyboardShortcuts from './keyboardshortcuts'

export default KeyboardShortcuts
